module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "a489ebb",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
